<template >
	<v-card class="padding elevation-0" flat>
        <h1 class="blue-grey--text">Filtro de ligações</h1>
        <p class="black--text">Obtenha dados precisos configurando o filtro abaixo</p>
        <div class="painel-pesquisa">
            <v-menu ref="inicio" :close-on-content-click="false" v-model="calendar1" :nudge-right="40" :return-value.sync="filtro.dataInicial" lazy="lazy" transition="scale-transition" offset-y="offset-y" full-width="full-width" min-width="290px">
                <v-text-field slot="activator" color="blue-grey" v-model="formatDateInicial" label="Data Inicial" prepend-icon="event" readonly="readonly"></v-text-field>
                <v-date-picker v-model="filtro.dataInicial" no-title="no-title" scrollable="scrollable" color="red" locale="pt-br" hint="DD/MM/YYYY format">
                    <v-spacer></v-spacer>
                    <v-btn flat="flat" color="red" @click="calendar1=false">Cancel</v-btn>
                    <v-btn flat="flat" color="red" @click="$refs.inicio.save(filtro.dataInicial),calendar1=false">OK</v-btn>
                </v-date-picker>
            </v-menu>
            <v-menu ref="fim" :close-on-content-click="false" v-model="calendar2" :nudge-right="40" :return-value.sync="filtro.dataFinal" lazy="lazy" transition="scale-transition" offset-y="offset-y" full-width="full-width" min-width="290px">
                <v-text-field slot="activator" color="blue-grey" v-model="formatDateFinal" label="Data Final" prepend-icon="event" readonly="readonly"></v-text-field>
                <v-date-picker v-model="filtro.dataFinal" no-title="no-title" scrollable="scrollable" color="red" locale="pt-br" hint="DD/MM/YYYY format">
                    <v-spacer></v-spacer>
                    <v-btn flat="flat" @click="calendar2=false">Cancel</v-btn>
                    <v-btn flat="flat" @click="$refs.fim.save(filtro.dataFinal),calendar2=false">OK</v-btn>
                </v-date-picker>
            </v-menu>
            <v-icon @click="">search</v-icon>
        </div>
        <v-divider class="mt-3"></v-divider>
        <v-card-title style="margin-top:50px;">
            <h1 class="blue-grey--text">Ligações</h1>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" color="blue-grey" append-icon="search" label="Pesquisar" single-line="single-line" hide-details="hide-details"></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="mensagens" :search="search" hide-actions="true"><template slot="items" slot-scope="props"><td class="text-xs-center">{{ props.item.datahora }}</td><td class="text-xs-center">{{ props.item.origem }}</td><td class="text-xs-center">{{ props.item.destino }}</td><td class="text-xs-center">{{ props.item.statusorigem }}</td><td class="text-xs-center">{{ props.item.duracao }}</td><td class="text-xs-center">{{ props.item.detahes }}</td></template>
            <v-alert
                slot="no-results" :value="true" color="error" icon="warning"> Sua busca por &quot;{{ search }}&quot; não retornou resultados.</v-alert>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
  data(){
    return{
      calendar1: false,
      calendar2: false,
      filtro:{
        dataInicial:null,
        dataFinal:null
      },
      search: '',
      headers: [
        { text: 'Data e Hora', value: 'datahora', align:'center' },
        { text: 'Origem', value: 'origem', align:'center' },
        { text: 'Destino', value: 'destino', align:'center' },
        { text: 'Status Origem', value: 'statusorigem', align:'center' },
        { text: 'Duração', value: 'duracao', align:'center' },
        { text: 'Detalhes', value: 'detahes', align:'center' }
      ],
      mensagens: [
        {
          value: false,
          datahora: 'Frozen Yogurt',
          origem: 159,
          destino: 6.0,
          statusorigem: 24,
          duracao: 4.0,
          detahes: 4.0
        }
      ]
    }
  },
  computed:{
    formatDateInicial()
    {
      if (!this.filtro.dataInicial) return null
      const [year, month, day] = this.filtro.dataInicial.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateFinal()
    {
      if (!this.filtro.dataFinal) return null
      const [year, month, day] = this.filtro.dataFinal.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style lang="stylus">
  .inputdate
    margin-top 30px
    border-bottom 1px solid #cccccc
    background-color #eee
    padding 8px
    border-radius 3px
    margin-right 10px


  .painel-pesquisa
    display flex
    justify-content space-between
    width 550px


</style>




// WEBPACK FOOTER //
// src/components/user/protaxi/Ligacoes.vue